module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "java-icon.9ed3a54f.svg" + "?" + Date.now();